import React from 'react'
import filterStylesComponents from '../../../../../assets/filterComponentsStyles'
import { useDispatch } from 'react-redux'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputBase,
  TextField,
  TextareaAutosize,
  Typography,
} from '@material-ui/core'
import { createDescription } from '../../PanelActions'
import colors from '../../../../../assets/colors'
import Icon from '@mdi/react'
import { mdiClose } from '@mdi/js'

const ModalCreateDescription = ({
  open = false,
  handleOpen = () => {},
  leadId = '',
}) => {
  const filterStyles = filterStylesComponents()
  const dispatch = useDispatch()

  const handleSubmit = async e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    try {
      const resp = await dispatch(createDescription(leadId, values))

      if (resp) {
        handleOpen()
      }
    } catch (e) {
      //
    }
  }

  return (
    <Dialog open={open} onClose={handleOpen} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography style={{ fontSize: '20px' }}>
              Adicionar Observação
            </Typography>
          </Grid>

          <Grid item>
            <IconButton onClick={handleOpen}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <InputBase
            name="description"
            label="Descrição"
            fullWidth
            required
            multiline
            inputProps={{
              style: {
                minHeight: '150px',
                maxHeight: '200px',
                padding: '12px',
              },
            }}
            style={{
              borderRadius: '15px',
              border: `1px solid ${colors.graylight}`,
              minHeight: '150px',
              padding: '8px',
              maxHeight: '200px',
              padding: '12px',
            }}
          />
        </DialogContent>

        <DialogActions>
          <Grid container alignItems="center" justifyContent="center">
            <Grid item>
              <Button
                type="submit"
                className={filterStyles.btnAdd}
                style={{ textTransform: 'none' }}
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default ModalCreateDescription
